import {LoginButtonColor, LoginButtonSize} from '@yandex-delivery/blocks'
import {HeaderDesktop} from '@yandex-delivery/order-layout-blocks'

import {User} from 'src/shared/components/desktop'
import {appConfig} from 'src/shared/config'

import {DEFAULT_TLD} from '../defaults'
import {controlPanel, linksList} from './country-consts'
import {HeaderRu} from './HeaderRu'
import {getCountryButton} from './utils'

type HeaderProps = {
  isFixed?: boolean
}

const {tld = 'ru'} = appConfig

const safeControlPanel = controlPanel[tld] || controlPanel[DEFAULT_TLD]
const controlPanelData = [...safeControlPanel, getCountryButton()]
const linksListData = linksList[tld] || linksList[DEFAULT_TLD]

export const Header: React.FC<HeaderProps> = props => {
  if (tld === 'ru') {
    return <HeaderRu sideSlot={<User color={LoginButtonColor.DARK} size={LoginButtonSize.S} />} {...props} />
  }
  return <HeaderDesktop controlPanelData={controlPanelData} linksList={linksListData} user={<User />} />
}
